import React from "react";
import {SuperAdminCompaniesStats} from "../SuperAdminCompaniesStats/SuperAdminCompaniesStats";

export const SuperAdminCompaniesDashboard = ({types, textType}) => {
    return <div className="AdminDashboard">
        <div className="reportsContent">
            <SuperAdminCompaniesStats types={types} textType={textType}/>
        </div>
    </div>
}